module.exports = __webpack_public_path__ + "media/Audio17_l.3ee8da7e.wav";